import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricCard = ({ title, value, subtitle, icon, trend, trendValue, variant = 'default' }) => {
  const variantStyles = {
    default: 'bg-card border-border',
    primary: 'bg-primary/5 border-primary/20',
    success: 'bg-success/5 border-success/20',
    warning: 'bg-warning/5 border-warning/20',
    error: 'bg-error/5 border-error/20'
  };

  const iconColors = {
    default: 'var(--color-primary)',
    primary: 'var(--color-primary)',
    success: 'var(--color-success)',
    warning: 'var(--color-warning)',
    error: 'var(--color-error)'
  };

  return (
    <div className={`${variantStyles?.[variant]} border rounded-xl p-4 md:p-6 transition-smooth hover-lift`}>
      <div className="flex items-start justify-between mb-3">
        <div className="flex-1 min-w-0">
          <p className="text-sm text-muted-foreground mb-1 truncate">{title}</p>
          <h3 className="text-2xl md:text-3xl font-bold text-foreground data-text">{value}</h3>
          {subtitle && (
            <p className="text-xs text-muted-foreground mt-1 truncate">{subtitle}</p>
          )}
        </div>
        <div className={`flex items-center justify-center w-10 h-10 md:w-12 md:h-12 rounded-lg ${variant === 'default' ? 'bg-primary/10' : 'bg-current/10'} flex-shrink-0`}>
          <Icon name={icon} size={20} color={iconColors?.[variant]} />
        </div>
      </div>
      {trend && trendValue && (
        <div className="flex items-center gap-1 mt-2">
          <Icon 
            name={trend === 'up' ? 'TrendingUp' : 'TrendingDown'} 
            size={14} 
            color={trend === 'up' ? 'var(--color-success)' : 'var(--color-error)'} 
          />
          <span className={`text-xs font-medium ${trend === 'up' ? 'text-success' : 'text-error'}`}>
            {trendValue}
          </span>
          <span className="text-xs text-muted-foreground">son 24 saat</span>
        </div>
      )}
    </div>
  );
};

export default MetricCard;